import { Injectable } from '@angular/core';
import { Constants } from '../../common/constants';

@Injectable({
    providedIn: 'root'
})
export class ChartToImageService {
    setChartImage(chartImgObj: { chartName: string; imgUri: string }) {
        // Finns det ingen bild sätter vi ingenting.
        if (chartImgObj.imgUri?.length === 0) return;

        // Vi sätter bara varje värde en gång. Annars riskerar vi att användaren ändrat urvalet med filter knapparna.
        switch (chartImgObj.chartName) {
            case Constants.DIAGRAM_NAMN.ARSSKADOR_GRAN:
                if (this.arskadorGran.length > 0) break;
                this.arskadorGran = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.ARSSKADOR_TALL:
                if (this.arsskadorTall.length > 0) break;
                this.arsskadorTall = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.TALL_PA_MAGRA_MARKER:
                if (this.tallMagraMarker.length > 0) break;
                this.tallMagraMarker = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.TALL_PA_MELLANMARK:
                if (this.tallMellanMarker.length > 0) break;
                this.tallMellanMarker = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.TALL_PA_BORDIGA_MARKER:
                if (this.tallBordigaMarker.length > 0) break;
                this.tallBordigaMarker = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.OSKADAD_TALL:
                if (this.oskadadTall.length > 0) break;
                this.oskadadTall = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.FOREKOMST_RASE:
                if (this.forekomstRase.length > 0) break;
                this.forekomstRase = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.KONKURRENS_RASE:
                if (this.konkurrensRase.length > 0) break;
                this.konkurrensRase = chartImgObj.imgUri;
                break;
            case Constants.DIAGRAM_NAMN.FODERPRODUCERANDE:
                if (this.utvFoderproducerande.length > 0) break;
                this.utvFoderproducerande = chartImgObj.imgUri;
                break;
            default:
                break;
        }
    }

    public arsskadorTall: string = '';
    public oskadadTall: string = '';
    public arskadorGran: string = '';
    public forekomstRase: string = '';
    public konkurrensRase: string = '';
    public tallMagraMarker: string = '';
    public tallMellanMarker: string = '';
    public tallBordigaMarker: string = '';
    public utvFoderproducerande: string = ''; // Saknar felmarginal
}
